import React from 'react';
import PropTypes from 'prop-types';

const YRToggle = ({ showGraph, onClick }) => {
    let showAs = 'Show as';
    let graph = 'Graph';
    let table = 'Table';

    const { lang } = document.documentElement;

    if (lang && lang === 'fr') {
        showAs = 'Montrer comme';
        graph = 'Graphique';
        table = 'Tableau';
    } else if (lang && lang === 'nl') {
        showAs = 'Geef weer als';
        graph = 'Grafiek';
        table = 'Tabel';
    }

    return (
        <div
            className="yr-toggle"
            role="tablist"
        >
            <span className="yr-toggle__text">{showAs}</span>

            <div className="yr-toggle__buttons">
                <button
                    type="button"
                    className={`yr-toggle__button ${showGraph ? ' is-active' : ''}`}
                    role="tab"
                    aria-selected={showGraph}
                    aria-label={`${showAs} ${graph}`}
                    tabIndex={showGraph ? '-1' : null}
                    onClick={() => { onClick(true); }}
                >
                    {graph}
                </button>
                <button
                    type="button"
                    className={`yr-toggle__button ${showGraph ? '' : ' is-active'}`}
                    role="tab"
                    aria-selected={!showGraph}
                    aria-label={`${showAs} ${table}`}
                    tabIndex={showGraph ? null : '-1'}
                    onClick={() => { onClick(false); }}
                >
                    {table}
                </button>
            </div>
        </div>
    );
};

YRToggle.propTypes = {
    showGraph: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default YRToggle;
